<link rel="ractive" href="./version-dropdown.html" name="c-version-dropdown">

<div class="c-package-install-block {{#unless type === 'npm'}}block-empty{{/unless}}">
	{{#if type === 'npm'}}
	<div class="package-install-wrapper">
		<div class="install-settings">
			<div>INSTALL</div>

			{{#if isDefaultPackage !== null}}
				<div class="switch-wrapper">
					<span>Type:</span>
					<input id="switch-id"
						type="checkbox"
						twoway="false"
						class="switch-input {{#if isDefaultPackage}}checked{{/if}}">

					<label for="switch-id" on-click="@this.handleEsmDefaultSwitch()" class="{{#unless installEsmSrc && installScriptSrc}}disabled{{/unless}}">
						<span class="{{#unless installEsmSrc}}disabled{{/unless}}">ESM</span>
						<span class="{{#unless installScriptSrc}}disabled{{/unless}}">Default</span>
					</label>
				</div>
			{{/if}}

			<div class="versions-wrapper">
				<span>Version:</span>
				<c-version-dropdown
					versions="{{[...versionsList, 'separator', ...packageVersionsList]}}"
					version="{{selectedVersion}}"
					useCustomIconStyles="true">
				</c-version-dropdown>
			</div>

			<button class="settings-btn" on-click="@this.set('mobileSettingsVisible', true)">
				<img width="24" height="24" src="{{@shared.assetsHost}}/img/icons/settings-white.svg">
			</button>

			{{#if mobileSettingsVisible}}
				<div class="overlay" on-click="@this.onClickMobileCancel()"></div>

				<div class="settings-mobile" slide-in slide-out>
					<div class="switch-wrapper">
						<span>Type:</span>
						<input id="switch-id" type="checkbox" twoway="false"
							class="switch-input {{#if isDefaultPackageTmp}}checked{{/if}}">

						<label for="switch-id" on-click="@this.handleMobileEsmDefaultSwitch()" class="{{#unless installEsmSrc && installScriptSrc}}disabled{{/unless}}">
							<span class="{{#unless installEsmSrc}}disabled{{/unless}}">ESM</span>
							<span class="{{#unless installScriptSrc}}disabled{{/unless}}">Default</span>
						</label>
					</div>

					<div class="versions-wrapper">
						<span>Version:</span>
						<c-version-dropdown
							versions="{{[...versionsList, 'separator', ...packageVersionsList]}}"
							version="{{selectedVersionTmp}}">
						</c-version-dropdown>
					</div>

					<button class="btn-primary" on-click="@this.onClickMobileApply()">Apply</button>
					<button class="btn-secondary" on-click="@this.onClickMobileCancel()">Cancel</button>
				</div>
			{{/if}}
		</div>

		<div class="horizontal-divider-19"></div>

		<div class="install-script {{#if isDefaultPackage === null && !package.moduleTypes.includes('none') && !package.styleTypes.includes('none')}}install-script-2{{/if}}">
			{{#if isDefaultPackage === true}}
				{{#if ~/packageJsEntrypoint}}
					<div class="script-wrapper-default">
						<div class="code-wrapper">
							<span class="script-tag">&#60;script src="</span>
							<span class="script-text">
								<a target="_blank" href="{{~/installScriptSrc}}">{{~/installScriptSrc}}</a>
							</span>

							<span class="script-tag">"&#62;&#60;/script&#62;</span>
						</div>

						<div class="btn-group btn-group_copy-dropdown">
							<button title="Copy to Clipboard" type="button" class="btn dropdown-toggle" data-toggle="dropdown"
								aria-haspopup="true" aria-expanded="false">
								<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/copy-btn.svg">
							</button>

							<ul class="dropdown-menu">
								<li>
									<a as-clipboard="'Copy URL to clipboard', 'right'" data-clipboard-text="{{~/installScriptSrc}}">
										Copy URL
									</a>
								</li>

								{{#if ~/packageJsHash}}
									<li>
										<a as-clipboard="'Copy SRI to clipboard', 'right'"
											data-clipboard-text="{{buildIntegrity(~/packageJsHash)}}">
											Copy SRI
										</a>
									</li>
								{{/if}}

								{{#if canBuildHtml(~/installScriptSrc)}}
									<li>
										<a as-clipboard="'Copy HTML to clipboard', 'right'"
											data-clipboard-text="{{buildHtml(~/installScriptSrc)}}">
											Copy HTML
										</a>
									</li>

									{{#if ~/packageJsHash}}
										<li>
											<a as-clipboard="'Copy HTML + SRI to clipboard', 'right'"
												data-clipboard-text="{{buildHtml(~/installScriptSrc, ~/packageJsHash)}}">
												Copy HTML + SRI
											</a>
										</li>
									{{/if}}
								{{/if}}
							</ul>
						</div>
					</div>
				{{/if}}

				{{#if ~/packageCssEntrypoint}}
					<div class="script-wrapper-default">
						<div class="code-wrapper">
							<span class="script-tag">&#60;link href="</span>
							<span class="script-text">
								<a target="_blank" href="{{~/installLinkHref}}">{{~/installLinkHref}}</a>
							</span>
							<span class="script-tag">" rel="stylesheet"&#62;</span>
						</div>

						<div class="btn-group btn-group_copy-dropdown">
							<button title="Copy to Clipboard" type="button" class="btn dropdown-toggle" data-toggle="dropdown"
								aria-haspopup="true" aria-expanded="false">
								<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/copy-btn.svg">
							</button>

							<ul class="dropdown-menu">
								<li>
									<a as-clipboard="'Copy URL to clipboard', 'right'" data-clipboard-text="{{~/installLinkHref}}">
										Copy URL
									</a>
								</li>

								{{#if ~/packageCssHash}}
									<li>
										<a as-clipboard="'Copy SRI to clipboard', 'right'"
											data-clipboard-text="{{buildIntegrity(~/packageCssHash)}}">
											Copy SRI
										</a>
									</li>
								{{/if}}

								{{#if canBuildHtml(~/installLinkHref)}}
									<li>
										<a as-clipboard="'Copy HTML to clipboard', 'right'"
											data-clipboard-text="{{buildHtml(~/installLinkHref)}}">
											Copy HTML
										</a>
									</li>

									{{#if ~/packageCssHash}}
										<li>
											<a as-clipboard="'Copy HTML + SRI to clipboard', 'right'"
												data-clipboard-text="{{buildHtml(~/installLinkHref, ~/packageCssHash)}}">
												Copy HTML + SRI
											</a>
										</li>
									{{/if}}
								{{/if}}
							</ul>
						</div>
					</div>
				{{/if}}
			{{elseif isDefaultPackage === false}}
				<div class="script-wrapper-esm">
					<div class="code-wrapper">
						<span class="script-tag">&#60;script type="module"&#62;</span>
						<span class="script-text">
							<span>import {{_.packageToImportName(name)}} from</span>
							<span>'<a target="_blank" href="{{~/installEsmSrc}}">{{~/installEsmSrc}}</a>'</span>
						</span>
						<span class="script-tag">&#60;/script&#62;</span>
					</div>

					<div class="btn-group btn-group_copy-dropdown">
						<button title="Copy to Clipboard" type="button" class="btn dropdown-toggle" data-toggle="dropdown"
							aria-haspopup="true" aria-expanded="false">
							<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/copy-btn.svg">
						</button>

						<ul class="dropdown-menu">
							<li>
								<a as-clipboard="'Copy URL to clipboard', 'right'" data-clipboard-text="{{~/installEsmSrc}}">
									Copy URL
								</a>
							</li>
							{{#if canBuildHtml(~/installEsmSrc)}}
								<li>
									<a as-clipboard="'Copy HTML to clipboard', 'right'"
										data-clipboard-text="{{buildHtml(~/installEsmSrc, '', _.packageToImportName(name))}}">
										Copy HTML
									</a>
								</li>
							{{/if}}
						</ul>
					</div>
				</div>
			{{/if}}
		</div>

		<div class="horizontal-divider-19"></div>

		{{#if isDefaultPackage && (isGuessedJsFile || isGuessedCssFile)}}
			<div class="install-default-warning">
				No default
				{{#if isGuessedJsFile && isGuessedCssFile}}
				files
				{{elseif isGuessedJsFile}}
				JS file
				{{elseif isGuessedCssFile}}
				CSS file
				{{/if}}
				<a href="/documentation#id-configuring-a-default-file-in-packagejson">set by the package author</a>
				so the {{#if isGuessedJsFile && isGuessedCssFile}}URLs are{{else}}URL is{{/if}} guessed.
				You can always <a on-click="@this.set('tabRoute', 'files')">browse all package files</a> to use
				{{#if isGuessedJsFile && isGuessedCssFile}}other ones{{else}}another one{{/if}}.
			</div>
		{{else}}
			<div class="install-esm-ctrls">
				<form class="jsfiddle-form" action="https://jsfiddle.net/api/post/library/pure" method="POST" target="_blank">
					<input type="hidden" name="title" value="{{#if isDefaultPackage}}jsDelivr{{else}}esm.run{{/if}} {{name}} demo">
					{{#if isDefaultPackage}}
					<input type="hidden" name="resources" value="{{installScriptSrc}}" twoway="false">
					{{else}}
					<input type="hidden" name="js" value="{{jsFiddleJsCode}}" twoway="false">
					{{/if}}
					<button type="submit" class="esm-ctrl" tabindex="2">Open in jsfiddle</button>
				</form>

				<a href="{{learnMoreHref}}" class="esm-ctrl">
					Learn more
				</a>
			</div>
		{{/if}}
	</div>
	{{/if}}
</div>


<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');
	const clipboard = require('../../assets/js/decorators/clipboard');
	const { buildIntegrity, canBuildHtml, buildHtml } = require('../../assets/js/utils/build-links');

	component.exports = {
		computed: {
			importName () {
				let name = this.get('name').split(/[ ._-]/g).reduce((acc, value) => {
					return acc + value.substr(0, 1).toUpperCase() + value.substr(1);
				}).replace(/[^a-zA-Z0-9_$]/g, '');

				if (/^\d/.test(name)) {
					return `_${name}`;
				}

				return name || 'm';
			},
			jsFiddleJsCode () {
				return `// See https://www.npmjs.com/package/${this.get('name')} documentation.\nimport * as ${this.get('importName')} from 'https://esm.run/${this.get('name')}';\n\nconsole.log(${this.get('importName')})\n`;
			},
		},
		decorators: {
			clipboard,
		},
		data () {
			return {
				_,
				versionsList: [
					'Static',
					'Latest Patch',
					'Latest Minor',
					'Latest Major',
				],
				isDefaultPackage: null,
				isDefaultPackageTmp: null,
				selectedVersion: 'Static',
				selectedVersionTmp: 'Static',
				isGuessedJsFile: false,
				isGuessedCssFile: false,
				buildIntegrity,
				canBuildHtml,
				buildHtml,
				mobileSettingsVisible: false,
				learnMoreHref: null,
				entrypoints: {},
			};
		},
		oninit () {
			if (this.get('type') !== 'npm') {
				return;
			}

			if (!Ractive.isServer) {
				this.observe('isDefaultPackage name', () => {
					let isDefaultPackage = this.get('isDefaultPackage');

					if (isDefaultPackage) {
						this.set('learnMoreHref', `/documentation#id-npm`);
					} else {
						this.set('learnMoreHref', '/esm');
					}
				});

				// update selectedVersion (and tmp version for mobile) when sharedVersion was changed within FilesTab
				this.observe('sharedVersion', (sharedVersion) => {
					let initVersion = this.get('initVersion');
					let updSelectedVersion;

					if (sharedVersion === initVersion) {
						updSelectedVersion = 'Static';
					} else {
						updSelectedVersion = sharedVersion;
					}

					this.set('selectedVersion', updSelectedVersion);
					this.set('selectedVersionTmp', updSelectedVersion);
				});

				// handle version selection
				this.observe('selectedVersion', (selectedVersion) => {
					// clear SRI hashes from previous version
					this.set('packageJsHash', null);
					this.set('packageCssHash', null);

					let installPackageVersion = '@';
					let packageName = this.get('name');
					let initVersion = this.get('initVersion');
					let packageType = this.get('type');
					let sharedVersion;

					if (selectedVersion === 'Static') {
						installPackageVersion += initVersion;
						sharedVersion = initVersion;
					} else if (selectedVersion === 'Latest Patch') {
						installPackageVersion += initVersion.split('.').slice(0, 2).join('.');
						sharedVersion = initVersion;
					} else if (selectedVersion === 'Latest Minor') {
						installPackageVersion += initVersion.split('.')[0];
						sharedVersion = initVersion;
					} else if (selectedVersion === 'Latest Major') {
						installPackageVersion = '';
						sharedVersion = initVersion;
					} else {
						installPackageVersion += selectedVersion;
						sharedVersion = selectedVersion;
					}

					// update sharedVersion
					this.set('sharedVersion', sharedVersion);

					http.fetchPackageEntrypoints(packageType, packageName, sharedVersion).then((data) => {
						// clear script src and links href from prev version
						this.set('installScriptSrc', null);
						this.set('installLinkHref', null);

						let packageJsEntrypoint = '';
						let packageCssEntrypoint = '';
						let isGuessedJsFile = false;
						let isGuessedCssFile = false;

						if (data.entrypoints.js) {
							if (data.entrypoints.js.guessed) {
								isGuessedJsFile = true;
							}

							packageJsEntrypoint = data.entrypoints.js.file;
							this.set('installScriptSrc', `https://cdn.jsdelivr.net/${packageType}/${packageName}${installPackageVersion}${packageJsEntrypoint}`);
							this.set('packageJsEntrypoint', packageJsEntrypoint);
						}

						if (data.entrypoints.css) {
							if (data.entrypoints.css.guessed) {
								isGuessedCssFile = true;
							}

							packageCssEntrypoint = data.entrypoints.css.file;
							this.set('installLinkHref', `https://cdn.jsdelivr.net/${packageType}/${packageName}${installPackageVersion}${packageCssEntrypoint}`);
							this.set('packageCssEntrypoint', packageCssEntrypoint);
						}

						this.set('isGuessedJsFile', isGuessedJsFile);
						this.set('isGuessedCssFile', isGuessedCssFile);
						this.set('entrypoints', data.entrypoints);

						http.fetchPackageFilesFlat(packageType, packageName, sharedVersion).then((data) => {
							if (packageJsEntrypoint) {
								data.files.forEach((file) => {
									if (file.name === this.get('packageJsEntrypoint')) {
										this.set('packageJsHash', file.hash);
									}
								});
							}

							if (packageCssEntrypoint) {
								data.files.forEach((file) => {
									if (file.name === this.get('packageCssEntrypoint')) {
										this.set('packageCssHash', file.hash);
									}
								});
							}
						});
					}).finally(() => {
						this.set('installEsmSrc', `https://cdn.jsdelivr.net/npm/${packageName}${installPackageVersion}/+esm`);
						let entrypointValues = Object.values(this.get('entrypoints'));

						if (!entrypointValues.length || (entrypointValues.every(e => e.guessed) && this.get('package.moduleTypes').indexOf('esm') !== -1)) {
							this.set('isDefaultPackage', false);
							this.set('isDefaultPackageTmp', false);
						} else {
							this.set('isDefaultPackage', true);
							this.set('isDefaultPackageTmp', true);
						}
					}).catch(() => {});
				});

				this.observe('mobileSettingsVisible', (newValue) => {
					let body = document.querySelector('body');

					if (newValue === true) {
						body.classList.add('noscroll');
					} else {
						body.classList.remove('noscroll');
					}
				});
			}
		},
		onClickMobileApply () {
			this.set('mobileSettingsVisible', false);
			this.set('isDefaultPackage', this.get('isDefaultPackageTmp'));
			this.set('selectedVersion', this.get('selectedVersionTmp'));
		},
		onClickMobileCancel () {
			this.set('mobileSettingsVisible', false);
			this.set('isDefaultPackageTmp', this.get('isDefaultPackage'));
			this.set('selectedVersionTmp', this.get('selectedVersion'));
		},
		handleEsmDefaultSwitch () {
			let installScriptSrc = this.get('installScriptSrc');
			let installEsmSrc = this.get('installEsmSrc');

			if (installScriptSrc && installEsmSrc) {
				this.toggle('isDefaultPackage');
			}
		},
		handleMobileEsmDefaultSwitch () {
			let installScriptSrc = this.get('installScriptSrc');
			let installEsmSrc = this.get('installEsmSrc');

			if (installScriptSrc && installEsmSrc) {
				this.toggle('isDefaultPackageTmp');
			}
		},
	};
</script>
